import styled from "styled-components";

export const Padding = styled.div`
  padding: ${({padding}) => padding};

  @media only screen and (max-width: 700px) {
    padding: ${({mobilePadding}) => mobilePadding};
  }
`;